module.exports = __webpack_public_path__ + "img/left-ad-5.3e0edc1e.png";